var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import styled from "styled-components";
import { colorTheme, textTheme } from "../themes";
import checkImg from "../assets/CheckBox/check.svg";
var HiddenCheckbox = styled.input.attrs(function () { return ({
    type: "checkbox",
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: none;\n  height: 0;\n  width: 0;\n"], ["\n  display: none;\n  height: 0;\n  width: 0;\n"])));
var Label = styled.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  cursor: pointer;\n\n  align-self: center;\n  padding: 0px 12px 0px 10px;\n"], ["\n  ", ";\n  color: ", ";\n  cursor: pointer;\n\n  align-self: center;\n  padding: 0px 12px 0px 10px;\n"])), textTheme.subtitle2, colorTheme.black);
export var Icon = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n  align-self: center;\n  justify-self: center;\n"], ["\n  margin: 0;\n  align-self: center;\n  justify-self: center;\n"])));
var StyledCheckbox = styled.label(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 5px;\n  margin-right: 0px;\n  align-self: center;\n  width: 16px;\n  height: 16px;\n  border: 2px solid ", ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n\n  input:checked ~ & {\n    border: 2px solid ", ";\n    background-color: ", ";\n  }\n"], ["\n  margin: 5px;\n  margin-right: 0px;\n  align-self: center;\n  width: 16px;\n  height: 16px;\n  border: 2px solid ", ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n\n  input:checked ~ & {\n    border: 2px solid ", ";\n    background-color: ", ";\n  }\n"])), colorTheme.divider, textTheme.checkbox, colorTheme.white, colorTheme.newBlue, colorTheme.newBlue);
var Container = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n"])));
export var Checkbox = function (_a) {
    var label = _a.label, id = _a.id, checked = _a.checked, value = _a.value, name = _a.name, onChange = _a.onChange;
    var _b = __read(useState(!!checked), 2), check = _b[0], setCheck = _b[1];
    var boxId = id || label + "-checkbox";
    var handleCheck = function (event) {
        setCheck(event.target.checked);
        if (onChange) {
            onChange(event);
        }
    };
    return (React.createElement(Container, null,
        React.createElement(HiddenCheckbox, { id: boxId, name: name, value: value, checked: !!check, onChange: handleCheck }),
        React.createElement(StyledCheckbox, { htmlFor: boxId }, check ? (value && typeof value === "number" ? (value) : (React.createElement(Icon, { src: checkImg }))) : ("")),
        React.createElement(Label, { htmlFor: boxId }, label)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=CheckBox.js.map